import axios from "axios";
import { AUTH_TOKEN, REACT_APP_PAM_API } from "../constants";

// RADIUS server registry, heartbeats and device activity (authnull-service
// internal/radius/routes.go). All POST under the PAM API; the org and tenant
// come from the session, so no body carries them. Responses are wrapped as
// { code, status, data }: these helpers hand `data` to onSuccess.

const headers = () => ({ withCredentials: true, "X-Authorization": AUTH_TOKEN() });

const call = (path) => ({ onSuccess, onFailure, ...body } = {}) =>
  axios
    .post(`${REACT_APP_PAM_API}${path}`, body, { headers: headers() })
    .then((res) => onSuccess && onSuccess(res?.data?.data ?? res?.data))
    .catch((err) => onFailure && onFailure(err));

// {} → [{ id, name, type, sourceIp, status: healthy|degraded|down|never_connected,
//        lastSeenAt, lastHealth: { bridgeVersion, hostname, checks: [{ name, ok, detail }] },
//        bridgeVersion, devicesUsing, lastLoginMs, loginCount, createdAt }]
export const listRadiusServers = call("/radius/ListServers");
// { name, type: "freeradius", sourceIp } → the new server (its id goes into app.env as RADIUS_SERVER_ID)
export const createRadiusServer = call("/radius/CreateServer");
// { id, name } → message
export const renameRadiusServer = call("/radius/RenameServer");
// { id } → message; 409 while devices still send logins to it
export const deleteRadiusServer = call("/radius/DeleteServer");
// {} → [{ id, radiusServerId, lastLoginMs, discovered, status: active|discovered|inactive }]
export const radiusDeviceActivity = call("/radius/DeviceActivity");
// { id, name, deviceType, nasIdentifier, radiusServerId } → message
export const updateRadiusDevice = call("/radius/UpdateDevice");

// The server's API status → the two states the console shows.
export const serverIsActive = (s) => s?.status === "healthy" || s?.status === "degraded";

export const radiusErrorText = (err, fallback = "Something went wrong.") =>
  err?.response?.data?.error || err?.response?.data?.message || fallback;

// lastHealth.checks[].name → label.
export const RADIUS_CHECK_LABELS = {
  freeradius_running: "FreeRADIUS running",
  udp_1812_listening: "UDP 1812 listening",
  config_valid: "Config valid",
  ad_reachable: "AD reachable",
  authn_reachable: "AuthNull reachable",
};
